module.exports = __webpack_public_path__ + "static/img/verticalBannerWithPuzzle_ba.85451937.png";